import { render, staticRenderFns } from "./NewTaskQueue.vue?vue&type=template&id=06ef1acc&"
import script from "./NewTaskQueue.vue?vue&type=script&lang=js&"
export * from "./NewTaskQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports